import { api } from "@/api";
import { syncServerClock } from "@/stores/serverClock";
import {
  DEFAULT_VIRTUAL_SPORT_TYPE,
  VirtualSportType,
  virtualStreamPath,
} from "./virtualSportType";

export interface VirtualTiming {
  phaseName: string;
  matchStart: number; // unix seconds
  matchEnd: number;
  nextBetstop: number;
  // The betstop after nextBetstop — the strip rolls its countdown to this the
  // instant nextBetstop hits 0 (no blank gap while the feed catches up).
  nextBetstopAfter: number;
  // Active phase end (SR's own countdown boundary — always a valid near future).
  phaseEndAt: number;
  // The week actually ON SCREEN — direct from SR's timeline feed. Stays on the
  // last week through the end-of-season celebration (no early jump to week 1).
  playingWeek: number;
  // Season end (last chunk end + celebration window).
  seasonEndAt: number;
}

// Current match-clock timing for a VR league. The live "▶ MM:SS" / betting
// countdown is computed client-side from these vs now. Null if unavailable.
// The response carries a server timestamp → sync the shared server-clock offset
// so every VR countdown ticks in lockstep with SR's absolute betstop.
export const getVirtualTiming = async (
  leagueId: number,
  sportType: VirtualSportType = DEFAULT_VIRTUAL_SPORT_TYPE
): Promise<VirtualTiming | null> => {
  const res = await api.client.get(virtualStreamPath(sportType, "timing"), {
    params: { leagueId },
  });
  syncServerClock(res.data?.serverTime);
  return res.data?.timing ?? null;
};
